import { BracketPositionPointCriteria } from "./BracketPositionPointCriteria"
import {PointsArrangements} from "./PointsArrangements"

export class BracketSettings{
    PositionGaugingPointsOnBrackets
    PositionGaugingPointsOnBays
    PositionPointCriteriaList: BracketPositionPointCriteria[];
    PointsArrangement: PointsArrangements;
    // PointsArrangements: string;
    PositionGaugingsforCriticalAreas: boolean
    CriticalAreaThreshold: number



}
